<script setup lang="ts">
import { useNotification } from "naive-ui";
import { onMounted } from "vue";
import { getUserId } from "@/util/api";
import { useNotificationStore } from "@/stores/useNotificationStore";
import { initBroadcasting } from "@/echo";

const store = useNotificationStore();
const notification = useNotification();

onMounted(async () => {
    if (await getUserId()) {
        store.load();
        initBroadcasting();
    }
    await getUserId().then((r: any) =>
        window.Echo.private(`form-submissions.` + r).listen(
            ".schedule.notification",
            (e: any) => {
                notification.create({
                    title: "New Notification",
                    content: e.message,
                    duration: 10000,
                });
                store.load();
            },
        ),
    );
});
</script>
